/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentCommentOutput } from './studentCommentOutput';

export interface LegacyRemark {
  id?: string;
  studentComment: StudentCommentOutput;
}
